import firebase from "../../config/firebase";
import { toast } from "react-toastify";

export const addContest = (data, onSuccess = () => {}) => {
  if (data.sportName !== "basketball") {
    delete data.gender;
  }
  return async (dispatch) => {
    let getContest = await firebase
      .firestore()
      .collection("contest")
      .orderBy("contestNumber", "desc")
      .limit(1)
      .get();
    let contestId;
    let contestNumber;
    if (getContest.empty) {
      contestId = "SC1";
      contestNumber = 1;
    } else {
      contestNumber = parseInt(getContest.docs[0].data().contestNumber) + 1;
      contestId = `SC${contestNumber}`;
    }
    let newData = {
      ...data,
      contestId,
      contestNumber,
    };
    await firebase
      .firestore()
      .collection("contest")
      .add(newData)
      .then((query) => {
        if (data.contestType == "Sport Contest") {
          // dispatch({ type: "ADD_CONTEST_SUCCESS" });
        } else {
          dispatch(getBrandAmbassodarContests());
        }
        onSuccess("success");
      })
      .catch((error) => {
        console.error("Error adding contest: ", error);
        onSuccess("error");
      });
  };
};

export const getContests = (
  startAfterDocument,
  prevObj,
  onSuccess = () => {}
) => {
  return async (dispatch) => {
    try {
      let query = firebase
        .firestore()
        .collection("contest")
        .where("contestType", "==", "Sport Contest");

      if (startAfterDocument) {
        query = query.startAfter(startAfterDocument);
      }
      query = query.limit(5);

      const querySnapshot = await query.get();
      const contests = prevObj || [];

      querySnapshot.forEach(async (doc) => {
        const docData = doc.data();
        contests.push({ id: doc.id, ...docData });
      });

      dispatch({
        type: "GET_CONTEST",
        payload: {
          contestData: contests,
          hasMoreDocuments: querySnapshot.docs.length >= 5,
          lastDocument:
            querySnapshot.docs.length > 0
              ? querySnapshot.docs[querySnapshot.docs.length - 1]
              : null,
        },
      });

      onSuccess();
    } catch (error) {
      console.error("Error getting contests: ", error);
      dispatch({ type: "GET_CONTEST_ERROR", payload: error.message });
      onSuccess();
    }
  };
};
export const getBrandAmbassodarContests = (
  startAfterDocument,
  prevObj,
  onSuccess = () => {}
) => {
  return async (dispatch) => {
    try {
      let query = firebase
        .firestore()
        .collection("contest")
        .where("contestType", "==", "Brand Ambassador Contest");

      if (startAfterDocument) {
        query = query.startAfter(startAfterDocument);
      }
      query = query.limit(5);

      const querySnapshot = await query.get();
      const contests = prevObj || [];

      querySnapshot.forEach(async (doc) => {
        const docData = doc.data();
        contests.push({ id: doc.id, ...docData });
      });

      dispatch({
        type: "GET_BRAND_AMBASSODAR_CONTEST",
        payload: {
          contestData: contests,
          hasMoreDocuments: querySnapshot.docs.length >= 5,
          lastDocument:
            querySnapshot.docs.length > 0
              ? querySnapshot.docs[querySnapshot.docs.length - 1]
              : null,
        },
      });

      onSuccess();
    } catch (error) {
      console.error("Error getting contests: ", error);
      dispatch({ type: "GET_CONTEST_ERROR", payload: error.message });
      onSuccess();
    }
  };
};
export const getParticipantList = (participantList, onSuccess = () => {}) => {
  return async (dispatch) => {
    try {
      const tempData = [];
      for (const participant of participantList) {
        const query = await firebase
          .firestore()
          .collection("users")
          .doc(participant)
          .get();
        const data = query.data();

        tempData.push({
          athlete_Id: query.id,
          athleteId: data.athleteID,
          athleteName: data.first_name + " " + data.last_name,
          email: data.email,
        });
      }
      onSuccess(tempData);
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
};

export const updateContestAthleteList = (
  contestId,
  athleteList,
  onSuccess = () => {}
) => {
  return async (dispatch) => {
    try {
      const contestRef = firebase
        .firestore()
        .collection("contest")
        .doc(contestId);
      await contestRef.update({
        participantList: athleteList,
      });

      // status = accepted in contest_athletes
      const athleteUpdates = athleteList.map(async (athleteId) => {
        const athleteRef = firebase
          .firestore()
          .collection("contest_athletes")
          .where("contestId", "==", contestId)
          .where("athleteId", "==", athleteId);

        const athleteSnapshot = await athleteRef.get();

        if (!athleteSnapshot.empty) {
          const athleteDoc = athleteSnapshot.docs[0];

          await athleteDoc.ref.update({
            status: "accepted",
          });
        } else {
          console.log("no contest_athletes entry found", { athleteId, contestId });
        }
      });

      await Promise.all(athleteUpdates);

      dispatch({
        type: "ADD_ATHLETE_IN_SPORT_CONTEST",
        payload: { contestId, athleteList },
      });
      onSuccess("Success");
    } catch (error) {
      onSuccess("Error");
      console.error("Error updating contest document:", error);
    }
  };
};
export const getBrandAmbassadorParticipants =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("contest_enrollment")
      .where("contest_id", "==", id)
      .where("status", "==", "Enrolled")
      .onSnapshot(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          let athleteVideos = await firebase
            .firestore()
            .collection("contest_videos")
            .where("contestEnrollmentId", "==", doc.id)
            .get();
          let athlete = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().athlete_id)
            .get();
          if (athleteVideos.empty) {
            temp_data.push({
              ...doc.data(),
              athleteVideos: "",
              athlete: athlete.data(),
              id: doc.id,
            });
          } else {
            temp_data.push({
              ...doc.data(),
              athleteVideos: athleteVideos.docs[0].data(),
              contest_videos_id: athleteVideos.docs[0].id,
              athlete: athlete.data(),
              id: doc.id,
            });
          }
        }
        dispatch({
          type: "GET_BRANDAMBASSADOR_PARTICIPANTS",
          payload: temp_data,
        });
        onComplete();
      });
  };
export const getBrandAmbassadorEliminatedParticipants =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("contest_enrollment")
      .where("contest_id", "==", id)
      .where("status", "==", "Eliminate")
      .onSnapshot(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          let athleteVideos = await firebase
            .firestore()
            .collection("contest_videos")
            .where("contestEnrollmentId", "==", doc.id)
            .get();
          let athlete = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().athlete_id)
            .get();
          if (athleteVideos.empty) {
            temp_data.push({
              ...doc.data(),
              athleteVideos: "",
              athlete: athlete.data(),
              id: doc.id,
            });
          } else {
            temp_data.push({
              ...doc.data(),
              athleteVideos: athleteVideos.docs[0].data(),
              contest_videos_id: athleteVideos.docs[0].id,
              athlete: athlete.data(),
              id: doc.id,
            });
          }
        }
        dispatch({
          type: "GET_BRANDAMBASSADOR_ELIMINATED_PARTICIPANTS",
          payload: temp_data,
        });
        onComplete();
      });
  };

export const getParticipants =
  (arry, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      let temp_data = [];
      for await (let doc of arry) {
        const querySnapshot = await firebase
          .firestore()
          .collection("users")
          .doc(doc)
          .get();
        if (querySnapshot.exists) {
          temp_data.push({ id: doc, ...querySnapshot.data() });
        } else {
        }
      }
      dispatch({
        type: "GET_PARTICIPANTS",
        payload: temp_data,
      });
      onComplete();
    } catch (error) {
      console.error("Error fetching participants:", error);
    }
  };

export const eliminateParticipants =
  (idArrays, onComplete = () => {}) =>
  async () => {
    try {
      for await (let id of idArrays) {
        await firebase
          .firestore()
          .collection("contest_enrollment")
          .doc(id)
          .update({
            status: "Eliminate",
          });
      }

      toast.success("Participants eliminated successfully!");
      onComplete();
    } catch (error) {
      console.error("Error eliminating participants:", error);
      toast.error("Failed to eliminate participants. Please try again.");
    }
  };

export const getVoters =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    await firebase
      .firestore()
      .collection("contest_videos")
      .doc(id)
      .collection("votes-details")
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          let fan = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().fan_id)
            .get();
          temp_data.push({ ...fan.data() });
        }
        dispatch({
          type: "GET_VOTERS",
          payload: temp_data,
        });
        onComplete();
      });
  };

export const updateContestLevel =
  (id, onComplete = () => {}) =>
  () => {
    firebase
      .firestore()
      .collection("contest")
      .doc(id)
      .get()
      .then(async (query) => {
        let update_new_statue = "";
        if (query.data().status == "Kick-off") {
          update_new_statue = "semi-final";
        }
        if (query.data().status == "semi-final") {
          update_new_statue = "final";
        }
        if (query.data().status == "final") {
          update_new_statue = "complete";
        }
        firebase.firestore().collection("contest").doc(id).update({
          status: update_new_statue,
        });
        onComplete();
      });
  };
export const winnerAmbassador =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    let athlete = await firebase
      .firestore()
      .collection("users")
      .doc(data.winnerId)
      .get();
    let leaderBoard = {
      athleteId: data.winnerId,
      athleteName: athlete.data().first_name + " " + athlete.data().last_name,
      athleteEmail: athlete.data().email,
    };
    const batch = firebase.firestore().batch();
    const contestDocRef = firebase
      .firestore()
      .collection("contest")
      .doc(data.contest_id);
    batch.update(contestDocRef, {
      leaderBoard: leaderBoard,
      winnerAmount: data.winningAmount,
      payment_id: data.payment_id,
      WinningVotes: data.WinningVotes,
      via: "paypal",
      status: "complete",
    });

    const walletLogsCollectionRef = firebase
      .firestore()
      .collection("wallet_logs");
    const newLogRef = walletLogsCollectionRef.doc();
    batch.set(newLogRef, {
      amount: data.winningAmount,
      createdAt: firebase.firestore.Timestamp.now(),
      paymentType: "payout",
      serviceType: "ambassador contest",
      userId: data.winnerId,
    });

    const walletCollectionRef = firebase.firestore().collection("wallet");
    const walletQuerySnapshot = await walletCollectionRef
      .where("userId", "==", data.winnerId)
      .get();
    if (walletQuerySnapshot.empty) {
      const newWalletDocRef = walletCollectionRef.doc();
      batch.set(newWalletDocRef, {
        amount: data.winningAmount,
        userId: data.winnerId,
      });
    } else {
      const existingWalletDocRef = walletCollectionRef.doc(
        walletQuerySnapshot.docs[0].id
      );
      batch.update(existingWalletDocRef, {
        amount: firebase.firestore.FieldValue.increment(data.winningAmount),
      });
    }

    await batch
      .commit()
      .then(() => {
        onComplete();
        toast.success("successfully add winner");
      })
      .catch((error) => {
        onComplete("error");
        toast.error("Failed to add winner.");
        console.error("Error writing documents: ", error);
      });
  };

export const addSportBadgeReward =
  (reward, onComplete = () => {}) =>
  async (dispatch) => {
    const db = firebase.firestore();
    const batch = db.batch();
    const storage = firebase.storage();
    const storageRef = storage.ref(`officialIdDocuments/${reward.qrCode.name}`);
    try {
      const snapshot = await storageRef.put(reward.qrCode);
      const downloadURL = await snapshot.ref.getDownloadURL();
      for (let id of reward.leaderData) {
        const walletLogRef = db.collection("wallet_logs").doc();
        batch.set(walletLogRef, {
          amount: reward.sportBadgeReward,
          createdAt: firebase.firestore.Timestamp.now(),
          paymentType: "payout",
          serviceType: "sport contest winner reward",
          userId: id.fanId,
        });

        const walletQuerySnapshot = await db
          .collection("wallet")
          .where("userId", "==", id.fanId)
          .get();

        if (walletQuerySnapshot.empty) {
          const newWalletRef = db.collection("wallet").doc();
          batch.set(newWalletRef, {
            amount: reward.sportBadgeReward,
            userId: id.fanId,
          });
        } else {
          const walletDocRef = walletQuerySnapshot.docs[0].ref;
          batch.update(walletDocRef, {
            amount: firebase.firestore.FieldValue.increment(
              reward.sportBadgeReward
            ),
          });
        }
      }

      const contestRef = db.collection("contest").doc(reward.contestId);
      batch.update(contestRef, {
        rewardedAmount: reward.sportBadgeReward,
        status: "rewarded",
        winnerQrCode: downloadURL,
      });

      await batch.commit();
      dispatch({
        type: "SPORT_BADGE_REWARD",
        payload: reward,
      });
      onComplete();
      toast.success("Reward added successfully");
    } catch (error) {
      onComplete("error");
      toast.warning("Reward error");
      console.error("Batch operation failed: ", error);
    }
  };

export const getSuggestAthlete =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      let querya = await firebase
        .firestore()
        .collection("contest")
        .doc(id)
        .collection("athlete-suggestions")
        .orderBy("created_at", "desc");
      if (lastDocument != "") {
        querya = querya.startAfter(lastDocument);
      }
      await querya
        .limit(5)
        .get()
        .then(async (query) => {
          if (query.empty) {
            onComplete("empty");
          } else {
            let data = [];
            for await (let doc of query.docs) {
              let athleteData = await firebase
                .firestore()
                .collection("users")
                .where("athleteID", "==", doc.data().athlete_id)
                .get();
              let school = await firebase
                .firestore()
                .collection("users")
                .doc(doc.data().coach_id)
                .get();
              data.push({
                id: doc.id,
                ...doc.data(),
                athlete: athleteData.docs[0].data(),
                school: school.data(),
              });
            }

            dispatch({
              type: lastDocument
                ? "MORE_GET_SUGGESTED_ATHLETES"
                : "GET_SUGGESTED_ATHLETES",
              payload: {
                data: data,
                lastDocument: query.docs[data.length - 1],
                hasMoreDocument: data.length == 5,
              },
            });
            onComplete("data");
          }
        });
    } catch (error) {
      console.log(error);
    }
  };
